import { IProfile } from 'interfaces/user.interfaces';
import {
  FORM_UUID_GENERAL_PRESCREENING,
  FORM_UUID_WEIGHT_LOSS_CLINIC,
} from 'constants/app.constants';

export const checkPatientInfo = (profile: IProfile | null, formUuid?: string): boolean => {
  if (!profile?.customer) {
    return false;
  }

  const { firstName, lastName, dob, gender, email, mobilePhone, landlinePhone, address, surgery } =
    profile.customer || {};

  if (
    !firstName ||
    !lastName ||
    !dob ||
    !gender ||
    !email ||
    (!mobilePhone && !landlinePhone) ||
    !address?.streetAddress ||
    !address?.city ||
    !address?.country ||
    !address?.postalCode
  ) {
    return false;
  }

  if (
    (formUuid === FORM_UUID_WEIGHT_LOSS_CLINIC || formUuid === FORM_UUID_GENERAL_PRESCREENING) &&
    !surgery
  ) {
    return false;
  }

  return true;
};
